import lrz from 'lrz'
import http from '@/base/api/public.js'
import {isJson, appendParam} from '@/module/memberCenter/common/methods.js'

/**
 * lrz压缩
 * @param file
 * @param width
 * @returns {Promise<any>}
 */
export default function lrzCompress(file, width) {
  return new Promise((resolve, reject) => {
    lrz(file, {width: width, fieldName: 'file'}).then(data => {
      // console.log(data)
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
}


/**
 * 表单json转FormData对象，用于表单文件提交
 * @param json
 */
export function jsonToFormData(json) {
  return jsonToFormData2(json, '', new FormData())
}

function jsonToFormData2(json, base, formData) {
  for (let k in json) {
    if (isJson(json[k])) {
      formData = jsonToFormData2(json[k], base + k + '.', formData)
    } else {
      formData.append(base + k, json[k])
    }
  }
  return formData
}

/**
 * 表单文件上传post请求
 * @param url
 * @param param
 * @returns {*|Promise<any>}
 */
export function requestPostFile(url, param) {
  return http.requestPostFile(url, jsonToFormData(param))
}

/**
 * 表单文件上传put请求
 * @param url
 * @param param
 * @returns {*|Promise<any>}
 */
export function requestPutFile(url, param) {
  return http.requestPutFile(url, jsonToFormData(param))
}

/**
 * 文件下载（get请求）
 * @param url
 * @param param
 */
export function fileDownload(url, param) {
  let elemIF = document.createElement('iframe')
  elemIF.src = url + appendParam(param)
  elemIF.style.display = 'none'
  document.body.appendChild(elemIF)
}






// WEBPACK FOOTER //
// ./src/common/fileUtil.js